// extracted by mini-css-extract-plugin
module.exports = {"linkList":"xt_xu"};